import { ShiftHours } from '@bemlo/enums'

import { Color } from '../constants'
import { IconName } from '../elements'

export const SHIFT_HOURS_STYLES: Record<
  ShiftHours,
  { icon: IconName; color: Color }
> = {
  DAY: {
    icon: 'DayIcon',
    color: Color.MEDIUM_BLUE,
  },
  EVENING: {
    icon: 'EveningIcon',
    color: Color.MEDIUM_RED,
  },
  NIGHT: {
    icon: 'NightIcon',
    color: Color.VIOLET,
  },
  LONG: {
    icon: 'DayEveningIcon',
    color: Color.PINK,
  },
}
